import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { TipoFretePipe } from './tipo-frete.pipe';
import { TipoFreteDescricaoPipe } from './tipo-frete-descricao.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TipoFretePipe,
        TipoFreteDescricaoPipe
    ],
    exports: [
        TipoFretePipe,
        TipoFreteDescricaoPipe
    ],
    providers: [
        TipoFretePipe,
        TipoFreteDescricaoPipe
    ]
})
export class TipoFretePipeModule { }
